import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SliceState = {
  phoneCode: string;
  mobileCode: string;
};

const initialState: SliceState = {
  phoneCode: "961",
  mobileCode: "961",
};

const supplierSlice = createSlice({
  name: "supplier",
  initialState,
  reducers: {
    setPhoneCode(state, action: PayloadAction<{ phoneCode: string }>) {
      const newItem = action.payload;
      state.phoneCode = newItem.phoneCode;
    },
    setMobileCode(state, action: PayloadAction<{ mobileCode: string }>) {
      const newItem = action.payload;
      state.phoneCode = newItem.mobileCode;
    },
  },
});

export const supplierActions = supplierSlice.actions;
export const supplierReducer = supplierSlice.reducer;
